import { ComponentStyleConfig } from "@chakra-ui/react";

export const TagTheme: ComponentStyleConfig = {
  baseStyle: {
    container: {
      fontFamily: "body",
    },
  },
  variants: {
    brand: {
      container: {
        bg: "brand.red.100",
        borderRadius: 12,
        color: "brand.gray.90",
        fontWeight: 500,
      },
    },
  },
};
